import * as _ from 'lodash';
import { AfterViewInit, Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appSetHeight]'
})
export class SetHeightDirective implements AfterViewInit {
  @HostListener('window:resize', [])
  onResize = _.throttle(this.setHeight, 100, {
    leading: true,
    trailing: true
  });

  @Input()
  heightAsPercentage = 100;

  @Input()
  marginBottom = 0;

  constructor(private el: ElementRef) {
  }

  ngAfterViewInit() {
    setTimeout(() => this.setHeight());
  }

  private setHeight() {
    let el = this.el.nativeElement;
    // Walk up DOM until we run out of offsetParents, accumulating offsetTop
    let offsetTop = el.offsetTop;
    while (!!el.offsetParent) {
      el = el.offsetParent;
      offsetTop += el.offsetTop;
    }
    // Now el is the body tag, so get clientHeight and calculate a height in px
    const height = (el.clientHeight - offsetTop - this.marginBottom) * this.heightAsPercentage / 100;

    this.el.nativeElement.style.height = `${height}px`;
  }
}
